import React, { Component } from 'react';
import './Help.css';

class Help extends Component {
	render() {
		let helpOptions = [
			{
				kbkey: 'SPACE',
				desc: 'Play / Pause video'
			},
			{
				kbkey: '↑',
				desc: 'Volume up'
			},
			{
				kbkey: '↓',
				desc: 'Volume down'
			},
			{
				kbkey: 'm',
				desc: 'Toggle mute'
			},
			{
				kbkey: 'r',
				desc: 'Change playback rate'
			},
			{
				kbkey: '1-7',
				desc: 'Show/hide sources'
			},
			{
				kbkey: 'q',
				desc: 'Previous slide'
			},
			{
				kbkey: 'w',
				desc: 'Next slide'
			},
			{
				kbkey: 'c',
				desc: 'Toggle compact controls'
			}
		];

		if (this.props.data.supportsCaptions) {
			helpOptions = helpOptions.concat([
				{
					kbkey: 's',
					desc: 'Toggle captions'
				}
			]);
		}

		if (this.props.data.supportsThumbnails) {
			helpOptions = helpOptions.concat([
				{
					kbkey: 't',
					desc: 'Toggle thumbnails'
				},
				{
					kbkey: '← or j',
					desc: 'Go backward 10 seconds'
				},
				{
					kbkey: '→ or k',
					desc: 'Go forward 10 seconds'
				},
				{
					kbkey: 'y',
					desc: 'Cycle thumbnails'
				}
			]);
		}

		if (this.props.data.supportsWhiteboard) {
			helpOptions = helpOptions.concat([
				{
					kbkey: '[ or ]',
					desc: 'Move whiteboard'
				}
			]);
		}

		helpOptions = helpOptions.concat([
			{
				kbkey: 'f',
				desc: 'Toggle fullscreen mode'
			},
			{
				kbkey: 'ESC',
				desc: 'Exit fullscreen mode'
			},
			{
				kbkey: '? or h',
				desc: 'Toggle help menu'
			}
		]);

		let total = helpOptions.length,
			col1 = [],
			col2 = [];

		helpOptions.forEach((option, i) => {
			i < total/2 ? col1.push(option) : col2.push(option);
		});
		return(

			<div id="help-container">
				<h2>Keyboard Shortcuts</h2>

				<div className="row">
					<div className="col">
						{ col1.map((option, i) => {
							return (<dl key={"col-1-" + i}>
								<dt>{option.kbkey}</dt>
								<dd>{option.desc}</dd>
							</dl>);
						}) }
					</div>
					<div className="col">
						{ col2.map((option, i) => {
							return (<dl key={"col-2-" + i}>
								<dt>{option.kbkey}</dt>
								<dd>{option.desc}</dd>
							</dl>);
						}) }
					</div>
				</div>
			</div>
		);
	}
}

export default Help;